import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { getIsAuthenticated, useAuthStore } from '@@scripts/store/useAuthStore';
import { useDevToolbarStore } from '@@scripts/store/useDevToolbarStore';

/**
 * Runs the route guards again when the user signs out, the session changes or the role changes,
 * including the developer toolbar's role. The guards only read the stores while a page loads.
 */
export const useRerunGuardsOnAuthChange = () => {
    const router = useRouter();

    useEffect(() => {
        // A 401 while the first page loaded signed the user out before this subscribed
        if (!getIsAuthenticated()) {
            void router.invalidate();
        }

        const unsubscribeAuth = useAuthStore.subscribe((state, previous) => {
            if (
                state.accessToken !== previous.accessToken ||
                state.userRole !== previous.userRole
            ) {
                void router.invalidate();
            }
        });
        const unsubscribeDevToolbar = useDevToolbarStore.subscribe((state, previous) => {
            if (state.userRole !== previous.userRole) {
                void router.invalidate();
            }
        });

        return () => {
            unsubscribeAuth();
            unsubscribeDevToolbar();
        };
    }, [router]);
};
